import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl, getAccess } from 'src/globals';
import { NavigationEnd, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { membership_returndata } from 'src/types/membership_returndata';

@Component({
  selector: 'app-membershiplist',
  templateUrl: './membershiplist.component.html',
  styleUrls: ['./membershiplist.component.css']
})
export class MembershiplistComponent implements OnInit {
  ListMemberships: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledMembership: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  ListMembershipTypes: any[]
  
  showCancelWarning: boolean = false;
  ChosenMembership: any;

  membershipbookings: any;
  //InScheduledSession: boolean = false;
  MembershipOrScheduledSession: string = "Memberships";

  cols: any[];

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 

    }

  getMembershipType(membershiptypeid: string)
  {
    let membershiptype = this.ListMembershipTypes.find(m => m.membershiptypeid == membershiptypeid);

    if(membershiptype != null)
    {
      return membershiptype.name;
    }
    else
    {
      return "";
    }
  }

  ngOnInit(): void {

    this.cols = [
      { field: 'customer.fullName', header: 'Name' },
      { field: 'customer.email', header: 'Email' },
      { field: 'customer.mobile', header: 'Mobile' },
      { field: 'membershipTypeName', header: 'Membership Type' },
      { field: 'salesid', header: 'Membership ID' },
      { field: 'enddateCSV', header: 'End Date' }
      ];

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("CLASSES", user)){

          this.router.events.forEach(item => {
            if (item instanceof NavigationEnd) 
            {
            // if(this.router.url == "/scheduledsessionlist")
            //   {
            //     this.InScheduledSession = true;
            //     this.MembershipOrScheduledSession = "Scheduled Sessions";
            //   }
            //   else
            //   {
            //     this.InScheduledSession = false;
                this.MembershipOrScheduledSession = "Memberships";
              //}
            }
          });

          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(Membership)
  {
    this.ChosenMembership = Membership;

    this.showCancelWarning = true;
    // this.http.delete(bmxurl + "Membership/" + this.VenueID + "/" + MembershipID).subscribe(response => {
    //   this.httpResponse = response
    //   if(this.httpResponse.succeeded == true)
    //   {
    //     this.messageService.add({severity:'success', summary:'Disabled', detail:'Membership successfully disabled'});
    //     this.router.navigateByUrl("/membershiplist");

    //     this.loadgrid(false);
    //   }
    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Membership'});
    // })


  }


  cancelMembership(){
    this.showCancelWarning = false;

      this.http.delete(bmxurl + "Membership/" + this.VenueID + "/" + this.ChosenMembership.membershipid).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded == true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Membership successfully cancelled'});
        this.router.navigateByUrl("/membershiplist");

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred cancelling this Membership'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
      this.http.get(bmxurl + "membershiptypelist/" + this.VenueID + "/false").subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.ListMembershipTypes = (response as membership_returndata).data;
  
          if ((response as membership_returndata).messages.length > 0)
          {
            (response as membership_returndata).messages.forEach(error => {
              this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
            });
          }

          this.http.get(bmxurl + "membershiplist/" + this.VenueID + "/" + showdisabled).subscribe(response => {
            this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.ListMemberships = (response as membership_returndata).data.filter(m => m.membershiptype == "MEMBERSHIP" || m.membershiptype == null || m.membershiptype == ""); 
              
              // Add membership type name to each membership record
              this.ListMemberships = this.ListMemberships.map(membership => {
                return {
                  ...membership,
                  membershipTypeName: this.getMembershipType(membership.membershiptypeid)
                };
              });
              this.ListMemberships.forEach(element => {
                element.enddateCSV = this.formatDateForExcel(element.enddate);
              });
      
              if ((response as membership_returndata).messages.length > 0)
              {
                (response as membership_returndata).messages.forEach(error => {
                  this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
                });
              }
            }
            else
            {
              this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Memberships, error: ' + this.httpResponse.messages[0]});
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
          });
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Memberships, error: ' + this.httpResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
      });

  }

  editData(EditData)
  {
    let MembershipID = EditData;
    this.router.navigateByUrl("/customermembershipedit/" + MembershipID);
  }

  formatDateForExcel(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = ('0' + d.getUTCDate()).slice(-2);
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const year = d.getUTCFullYear();
    const hours = ('0' + d.getUTCHours()).slice(-2);
    const minutes = ('0' + d.getUTCMinutes()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "membership/" + this.VenueID + "/" + element.membershipid).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.loadgrid(false);
      } 
      else{
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error disabling Memberships, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error disabling Memberships, error: ' + error.messages});
    })
    });
    
  }

  
  }
